import React, { createContext, useContext, useEffect, useState } from "react";
import { login, verifyOTP, logout } from "action/auth";
import { ALLOWED_ROLES } from "constants/CommonConstants";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user: null,
    token: null,
    role: null,
  });

  const [loading, setLoading] = useState(true);

  // Restore session
  useEffect(() => {
    const stored = localStorage.getItem("p");
    if (stored) {
      setAuth(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const loginWithPassword = async (loginData) => {
    const res = await login(loginData);

    if (res.code === 200) {
      if (!ALLOWED_ROLES.includes(res.data?.role)) {
        return { success: false, message: "Access denied" };
      }

      setAuth(res.data);
      localStorage.setItem("p", JSON.stringify(res.data));

      return { success: true, data: res.data };
    }

    return { success: false, message: res?.message };
  };

  const verifyOtpLogin = async (bodyData) => {
    const res = await verifyOTP(bodyData);

    if (res.code === 200) {
      if (!ALLOWED_ROLES.includes(res.data?.role)) {
        return { success: false, message: "Access denied" };
      }

      setAuth(res.data);
      localStorage.setItem("p", JSON.stringify(res.data));

      return { success: true, data: res.data };
    }

    return { success: false, message: res?.message };
  };

  const logoutUser = async () => {
    try {
      await logout();
    } finally {
      localStorage.removeItem("p");
      setAuth({ user: null, token: null, role: null });
    }
  };

  return (
    <AuthContext.Provider
      value={{
        ...auth,
        isAuthenticated: !!auth?.token,
        loading,
        loginWithPassword,
        verifyOtpLogin,
        logoutUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
